import { Box } from "../../box";
import { ClearToolbar, useToolbarProps } from "../../toolbar";
import { forwardRef } from "react";
import { FieldContext } from "./FieldContext";
import { mergeProps } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { useFormField } from "../../form";
import { useGroupField } from "./useGroupField";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerGroupField(props) {
  const [formProps] = useFormField();
  const [toolbarProps] = useToolbarProps();
  const {
    as = DefaultElement,
    children,
    className,
    disabled,
    fluid,
    forwardedRef,
    id,
    required,
    validationState,
    ...rest
  } = mergeProps(props, formProps, toolbarProps);
  const fluidValue = useResponsiveValue(fluid);
  const {
    fieldContext,
    fieldProps
  } = useGroupField({
    className,
    disabled,
    fluid: fluidValue,
    forwardedRef,
    id,
    required,
    validationState
  });
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as
    }, fieldProps),
    children: /*#__PURE__*/_jsx(ClearToolbar, {
      children: /*#__PURE__*/_jsx(FieldContext.Provider, {
        value: { ...fieldContext,
          isGroup: true
        },
        children: children
      })
    })
  });
}
InnerGroupField.defaultElement = DefaultElement;
export const GroupField = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerGroupField, { ...props,
  forwardedRef: ref
}));